module.exports = __webpack_public_path__ + "img/chuttersnap-6xB6mxsLTV0-unsplash.aba39b95.jpg";